export default __webpack_public_path__ + "static/myltf_logo_transparent-50e29da6fb2b963db666cd6dcd8f5ea6.png";